export default "__VITE_ASSET__yWEMppUB__"